
import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import DetailClientManagementV1 from "../clients/client-management/detail/index.vue";
import DetailClientManagementV2 from "../clients-v2/management/detail/index.vue";
import { Options, Vue } from "vue-class-component";
@Options({
  components: {
    DetailClientManagementV1,
    DetailClientManagementV2,
  },
})
export default class EntryClient extends Vue {
  get isClientVersionV2() {
    return FlagsPermissionClient.client_v2_enable.isEnabled();
  }

  get renderedPage(): string {
    return this.isClientVersionV2
      ? "DetailClientManagementV2"
      : "DetailClientManagementV1";
  }
}
